// The es locale dataset must be loaded before constructing the displayer,
// otherwise Hermes / RN throws "Missing locale data for es" at module load.
import "@formatjs/intl-displaynames/locale-data/es.js";
import { CountryCode, getCountries } from "libphonenumber-js";

let displayer: Intl.DisplayNames | null = null;

function getDisplayer(): Intl.DisplayNames | null {
  if (displayer) return displayer;
  try {
    displayer = new Intl.DisplayNames("es", { type: "region" });
    return displayer;
  } catch {
    return null;
  }
}

export const getCountryName = (code: string) => {
  if (!code || code === "Others") return "Otros";
  try {
    return getDisplayer()?.of(code) ?? "Otros";
  } catch {
    return "Otros";
  }
};

export const getGenderName = (code: string) => {
  switch (code) {
    case "M":
    case "Male":
      return "Masculino";
    case "F":
    case "Female":
      return "Femenino";
    case "U":
    case "Other":
      return "No especificado";
    default:
      return code;
  }
};

// Builds a flag emoji from an ISO 3166-1 alpha-2 code by combining the two
// regional-indicator symbols (U+1F1E6 = "A"), e.g. "CL" -> \u{1F1E8}\u{1F1F1}.
export const countryCodeToFlag = (code: string): string => {
  if (!code || code.length !== 2) return "";
  const codePoints = [...code.toUpperCase()].map(
    (char) => 0x1f1e6 + (char.charCodeAt(0) - 0x41),
  );
  return String.fromCodePoint(...codePoints);
};

// Narrows a live country's ISO code (a plain `string` from the backend) into
// libphonenumber-js's `CountryCode` literal union, so it can seed a phone
// field's `countryCode` without an unsound cast.
export const isPhoneCountryCode = (
  code: string | null | undefined,
): code is CountryCode =>
  !!code &&
  getCountries().some((phoneCountryCode) => phoneCountryCode === code);
